<template>
  <div class="PageBox">
    <div class="ScrollBox">
     <van-nav-bar
     			fixed
     			:border="false"
     			:title="$t('user.menu[14]')"
     			left-arrow
     			@click-left="$router.go(-1)"
     		/>
     <div style="padding: .26rem;line-height: 1.2rem;" v-html="InitData.setting.smart_desc"></div>
     <van-button block type="danger" :loading="isSubmit" :loading-text="$t('user.default[11]')" style="font-size: 18px;" @click="onSubmit">{{$t('user.default[11]')}}</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Smart',
  components: {

  },
  props: [],
  data() {
    return {
      
      isSubmit: false,
      
    }
  },
  computed: {

  },
  watch: {

  },
  created() {

  },
  mounted() {

  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
    onSubmit() {
			
      this.$Dialog.Confirm(this.$t('common[2]'),()=>{
          this.isSubmit = true
          this.$Model.doSmart((data)=>{
          this.isSubmit = false
          //if(data.code == 201) {
            console.log(data)
            this.$Dialog.Alert(data.msg?data.msg:data.code_dec);
          //}
        })
      })

      
	  
    }
}
  
}
</script>
<style scoped>
.PageBox{color:#000;}
</style>